// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectWeeklyEarlyLateProgress(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/weekly_progress_baseline_actual`);
}
